export default __webpack_public_path__ + "static/abx-logo.5790df6d9ea0656bfdd976356345080a.svg";